module.exports = __webpack_public_path__ + "img/upRefund.9fa70347.svg";